// src/utils/enderecoEntregaUtils.js
import { normalizeTextForSearch } from './stringUtils';

export const reconciliarCidadeEntrega = (cidadeId, cidades) =>
  cidades.find((cidade) => Number(cidade.id) === Number(cidadeId)) ||
  (cidades.length === 1 ? cidades[0] : null);

export const reconciliarBairroEntrega = (endereco, taxas) => {
  const bairros = taxas.filter((taxa) => Number(taxa.cidadeId) === Number(endereco?.cidadeId));
  const nome = normalizeTextForSearch(endereco?.bairro);
  return bairros.find((taxa) => Number(taxa.id) === Number(endereco?.taxaEntregaBairroId)) ||
    bairros.find((taxa) => nome && normalizeTextForSearch(taxa.descricao) === nome) || null;
};

// Cidade padrão do delivery: o combo de cidade não é exibido no App e o endereço usa sempre a cidade 1.
export const CIDADE_PADRAO_ID = 1;

// Retorna a cidade padrão quando ela estiver na lista de entrega; senão a primeira disponível.
export const obterCidadeEntregaPadrao = (cidades) =>
  cidades.find((cidade) => Number(cidade.id) === CIDADE_PADRAO_ID) || cidades[0] || null;
